/**
 * Espone i colori del design system per essere utilizzati all'interno dell'applicativo (ex. per le icone)
 */
export function useDesignSystem() {
  return {
    design_colors: {
      primary: '#0069B4',
      rowHover: '#f1f5f9',
      secondary: '#888',
      secondaryLight: "#9ca3af",
      ternary: '#F4F4F4',
      omnia: '#FF912C',
      footer: '#706f6f',
      success: '#4CAF50',
      "success--bg": '#EDF7ED',
      warning: '#856404',
      "warning--bg": '#fff3cd',
      error: '#EF5350',
      "error--bg": '#FDEDED',
      info: '#0069B4',
      "info--bg": '#ebf2f8',
      "inactive--bg": '#ddd'
    }
  }
}